import { render, staticRenderFns } from "./myPerformance.vue?vue&type=template&id=82afcd00&scoped=true&"
import script from "./myPerformance.vue?vue&type=script&lang=js&"
export * from "./myPerformance.vue?vue&type=script&lang=js&"
import style0 from "./myPerformance.vue?vue&type=style&index=0&id=82afcd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82afcd00",
  null
  
)

export default component.exports